var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-md-5",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',{staticClass:"secondary--text"},[_vm._v("Pacientes")]),_c('v-divider',{staticClass:"mb-8 mt-2"}),_c('PatientsList',{attrs:{"showPatientDialog":false,"clickable":true},on:{"patient-click":_vm.handlePatientClick}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }